module.exports = __webpack_public_path__ + "static/user-list-one-color-dont-7be126f71ec7b5af70ea81933632a59e.png";